import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useGeolocation } from 'state/geolocation';
import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { isMobile } from 'utils/environment';
import { GeolocationPermissionStates } from 'utils/geolocation';
import { routes } from 'utils/routing';

import { GeolocationModalView } from './geolocation-modal-view';

export const AutoGeolocationModal = () => {
  const { permission, setPermission } = useGeolocation();
  const { determiningLocaleComplete } = useLocale();
  const navigate = useNavigate();
  const enableAutoLocale = useFlag(LaunchDarklyFlag.ENABLE_AUTO_LOCALE);
  // This ensures that autoSelectRestaurant hook does not run prior to correct domain / locale being selected
  const autoLocaleComplete = !enableAutoLocale || determiningLocaleComplete;
  // Auto geolocation modal should only show on mobile sized devices (including mobile on web app)
  const openModalOnMount = isMobile() && permission === GeolocationPermissionStates.PROMPT;
  const [modalOpen, setModalOpen] = useState(openModalOnMount);

  const handleGeolocationPrompt = () => {
    setModalOpen(false);
    setPermission(GeolocationPermissionStates.CHECKING);
  };

  const selectManually = () => {
    setModalOpen(false);
    navigate(routes.storeLocator);
    setPermission(GeolocationPermissionStates.DENIED);
  };

  const dismissModal = () => {
    setModalOpen(false);
    setPermission(GeolocationPermissionStates.PROMPT);
  };

  return modalOpen && autoLocaleComplete ? (
    <GeolocationModalView
      dismissModal={dismissModal}
      selectManually={selectManually}
      handleGeolocationPrompt={handleGeolocationPrompt}
    />
  ) : null;
};
